<template>
  <div class="inner-container" :class="{ 'min-container': !getTabs }">
    <div class="page-header">
      <h1>{{ $t("Départements - Coefficients de Précarité") }}</h1>
      <b-button variant="secondary" @click="goBack" class="mr-2">
        <font-awesome-icon icon="arrow-left" /> {{ $t("Retour") }}
      </b-button>
    </div>

    <div class="content">
      <div class="alert alert-info">
        <strong>Opération :</strong> {{ currentOperation?.label || 'Non définie' }}
      </div>

      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>{{ $t("Département") }}</th>
              <th>{{ $t("Grande Précarité") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="dept in departements" :key="dept.code">
              <td>
                <strong>{{ dept.code }}</strong> - {{ dept.nom }}
              </td>
              <td>
                <div v-if="!dept.editingGrande" class="d-flex align-items-center">
                  <span class="mr-2">{{ dept.grande_precarite }} %</span>
                  <b-button 
                    variant="outline-primary" 
                    size="sm" 
                    @click="startEdit(dept, 'grande')"
                  >
                    <font-awesome-icon icon="pen" />
                  </b-button>
                </div>
                <div v-else class="d-flex align-items-center">
                  <b-form-input 
                    v-model="dept.grande_precarite_temp" 
                    type="number" 
                    step="0.01"
                    size="sm"
                    class="mr-2"
                    style="width: 100px;"
                  />
                  <b-button 
                    variant="success" 
                    size="sm" 
                    @click="saveEdit(dept, 'grande')"
                    class="mr-1"
                  >
                    <font-awesome-icon icon="check" />
                  </b-button>
                  <b-button 
                    variant="secondary" 
                    size="sm" 
                    @click="cancelEdit(dept, 'grande')"
                  >
                    <font-awesome-icon icon="times" />
                  </b-button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["getTabs"]),
  },
  data() {
    return {
      currentOperation: null,
      departements: [
        {
          code: "01",
          nom: "Ain",
          grande_precarite: 1.2,
          precarite_energetique: 1.1,
          editingGrande: false,
          editingEnergetique: false,
          grande_precarite_temp: null,
          precarite_energetique_temp: null
        },
        {
          code: "02",
          nom: "Aisne",
          grande_precarite: 1.3,
          precarite_energetique: 1.2,
          editingGrande: false,
          editingEnergetique: false,
          grande_precarite_temp: null,
          precarite_energetique_temp: null
        },
        {
          code: "03",
          nom: "Allier",
          grande_precarite: 1.1,
          precarite_energetique: 1.0,
          editingGrande: false,
          editingEnergetique: false,
          grande_precarite_temp: null,
          precarite_energetique_temp: null
        },
        {
          code: "04",
          nom: "Alpes-de-Haute-Provence",
          grande_precarite: 1.0,
          precarite_energetique: 1.1,
          editingGrande: false,
          editingEnergetique: false,
          grande_precarite_temp: null,
          precarite_energetique_temp: null
        },
        {
          code: "05",
          nom: "Hautes-Alpes",
          grande_precarite: 1.1,
          precarite_energetique: 1.2,
          editingGrande: false,
          editingEnergetique: false,
          grande_precarite_temp: null,
          precarite_energetique_temp: null
        },
        {
          code: "06",
          nom: "Alpes-Maritimes",
          grande_precarite: 0.9,
          precarite_energetique: 0.8,
          editingGrande: false,
          editingEnergetique: false,
          grande_precarite_temp: null,
          precarite_energetique_temp: null
        },
        {
          code: "07",
          nom: "Ardèche",
          grande_precarite: 1.2,
          precarite_energetique: 1.1,
          editingGrande: false,
          editingEnergetique: false,
          grande_precarite_temp: null,
          precarite_energetique_temp: null
        },
        {
          code: "08",
          nom: "Ardennes",
          grande_precarite: 1.4,
          precarite_energetique: 1.3,
          editingGrande: false,
          editingEnergetique: false,
          grande_precarite_temp: null,
          precarite_energetique_temp: null
        },
        {
          code: "09",
          nom: "Ariège",
          grande_precarite: 1.3,
          precarite_energetique: 1.2,
          editingGrande: false,
          editingEnergetique: false,
          grande_precarite_temp: null,
          precarite_energetique_temp: null
        },
        {
          code: "10",
          nom: "Aube",
          grande_precarite: 1.2,
          precarite_energetique: 1.1,
          editingGrande: false,
          editingEnergetique: false,
          grande_precarite_temp: null,
          precarite_energetique_temp: null
        }
      ]
    };
  },
  
  mounted() {
    // Récupérer l'opération depuis les paramètres de route
    const operationId = this.$route.query.operationId;
    if (operationId) {
      // Ici vous pourriez charger l'opération depuis votre store/API
      this.currentOperation = {
        id: operationId,
        label: "BAR-EN-101 - Isolation combles" // Exemple
      };
    }
  },
  
  methods: {
    goBack() {
      this.$router.push('/Precarites');
    },
    
    startEdit(dept, type) {
      if (type === 'grande') {
        dept.editingGrande = true;
        dept.grande_precarite_temp = dept.grande_precarite;
      } else {
        dept.editingEnergetique = true;
        dept.precarite_energetique_temp = dept.precarite_energetique;
      }
    },
    
    saveEdit(dept, type) {
      if (type === 'grande') {
        dept.grande_precarite = parseFloat(dept.grande_precarite_temp);
        dept.editingGrande = false;
        dept.grande_precarite_temp = null;
      } else {
        dept.precarite_energetique = parseFloat(dept.precarite_energetique_temp);
        dept.editingEnergetique = false;
        dept.precarite_energetique_temp = null;
      }
      
      // Ici vous pourriez sauvegarder en base de données
      console.log(`Sauvegarde ${type} pour département ${dept.code}`);
    },
    
    cancelEdit(dept, type) {
      if (type === 'grande') {
        dept.editingGrande = false;
        dept.grande_precarite_temp = null;
      } else {
        dept.editingEnergetique = false;
        dept.precarite_energetique_temp = null;
      }
    }
  }
};
</script>

<style scoped>
.table th {
  background-color: #24316d;
  color: white;
  border: none;
}

.table-responsive {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.alert-info {
  background-color: #e3f2fd;
  border-color: #2196f3;
  color: #1976d2;
}
</style>